import type { CallCenterAssistanceViewModel } from './CallCenterAssistanceViewModel'
import { CallOptionTypesDialog } from './CallOptionsDialog'
import { observer } from 'mobx-react-lite'
import { CallSalesRepDialog } from './CallSalesRepDialog'
import type { IconName } from '@/components/Icon'

export type CallOptionId = 'CallSalesRep' | 'SelfOnboard'

export interface CallOption {
  id: CallOptionId
  title: string
  description: string
  icon: IconName
  recommended?: boolean
}

export const callSalesRepOption: CallOption = {
  id: 'CallSalesRep',
  title: 'Call a Representative Now',
  description: 'Get immediate assistance and answers to all your questions',
  icon: 'call-start-call',
  recommended: true,
}

export const selfOnboardOption: CallOption = {
  id: 'SelfOnboard',
  icon: 'legend-individual',
  title: 'Self-onboard',
  description: 'Start on your own by answering a few quick questions',
}

const options = [callSalesRepOption, selfOnboardOption]

interface CallCenterContainerProps {
  vm: CallCenterAssistanceViewModel
}

export const CallAssistanceDialogsContainer = observer(
  ({ vm }: CallCenterContainerProps) => {
    const items = !vm.showSelfOnboarding
      ? options.filter((o) => o.id !== 'SelfOnboard')
      : options

    return (
      <>
        <CallOptionTypesDialog
          isOpen={vm.callOptionsModalVm.showing}
          onClose={vm.callOptionsModalVm.close}
          isNextDisabled={vm.selectedCallOption === null}
          onNext={() => vm.next()}
          options={items}
          selectOption={vm.selectCallOption}
          activeId={vm.selectedCallOption}
        />
        <CallSalesRepDialog
          isOpen={vm.callSalesRepModalVm.showing}
          onClose={vm.callSalesRepModalVm.close}
          phoneNumber={vm.callCenterNumber}
        />
      </>
    )
  },
)
